import { useState } from 'react';
import type { ReactNode } from 'react';
import { authService } from '../services/authService';
import type { LoginRequest } from '../services/authService';
import { setSentryUser, clearSentryUser } from '../lib/sentry';
import { AuthContext } from './authContextDef';

export function AuthProvider({ children }: { children: ReactNode }) {
  const [user, setUser] = useState(() => authService.getCurrentUser());
  const [isLoading] = useState(false);

  const login = async (request: LoginRequest) => {
    const response = await authService.login(request);
    setUser(response.user);
    // Plan PII kuralı: email/name yollamıyoruz. SaaS admin rolü implicit (super-admin),
    // o yüzden role tag set edilmiyor — tek tag `project=mentis` + `deployable=admin-panel`.
    setSentryUser({ id: response.user.id });
  };

  const logout = () => {
    authService.logout();
    setUser(null);
    clearSentryUser();
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        isAuthenticated: !!user,
        isLoading,
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}
